import Checkbox from '@/common-utils/components/ui/checkbox';

const ColumnSelection = (columnId, singleSelection = false, maxPicks = null) => {
    return {
        id: `${columnId}-selector`,
        header: ({ table }) => {
            // Page rows
            const pageRows = table.getPaginationRowModel().rows;
            const totalPageRowsNumber = pageRows.length;

            // All rows selection
            const allSelected = table.getState().rowSelection;
            const allSelectedNumber = Object.keys(allSelected).length;

            // Count rows selected per page
            const selectedPageRowsCount = pageRows.filter((row) => allSelected[row.id]).length;

            // Count the number of selectable rows
            const couldBeSelected = maxPicks !== null ? Math.max(maxPicks - allSelectedNumber, 0) : totalPageRowsNumber;

            // Count the selection area per page
            const selectionAreaSize = maxPicks !== null ? Math.min(totalPageRowsNumber, couldBeSelected + selectedPageRowsCount) : totalPageRowsNumber;

            // Checked state is based on current page only
            const isChecked = selectionAreaSize && (selectedPageRowsCount === selectionAreaSize) || (selectedPageRowsCount > 0 && 'indeterminate');

            return (
                <Checkbox
                    checked={isChecked}
                    onCheckedChange={(value) => {
                        if (!singleSelection) {
                            if (value) {
                                // Select all the page rows OR only rows that could be selected
                                const selection = { ...allSelected };
                                pageRows.slice(0, Math.min(totalPageRowsNumber, couldBeSelected)).forEach((row) => {
                                    selection[row.id] = true;
                                });
                                table.setRowSelection(selection);
                            } else {
                                // Deselect
                                const selection = { ...allSelected };
                                pageRows.forEach((row) => {
                                    delete selection[row.id];
                                });
                                table.setRowSelection(selection);
                            }
                        }
                    }}
                    aria-label='Select all on page'
                    disabled={singleSelection}
                />
            );
        },
        cell: ({ row, table }) => {
            const allSelected = table.getState().rowSelection;
            const selectedRowsCount = Object.keys(allSelected).length;
            const isRowSelected = row.getIsSelected();

            return (
                <Checkbox
                    checked={isRowSelected}
                    onCheckedChange={(value) => {
                        if (singleSelection) {
                            table.setRowSelection({ [row.id]: true });
                        }
                        // Break action when max picks is reached
                        else if (!isRowSelected && maxPicks !== null && selectedRowsCount >= maxPicks) {
                            return;
                        }
                        else {
                            row.toggleSelected(!!value);
                        }
                    }}
                    aria-label='Select row'
                    disabled={!isRowSelected && maxPicks !== null && selectedRowsCount >= maxPicks && !singleSelection}
                />
            );
        },
        enableSorting: false,
        enableHiding: false
    };
};

export default ColumnSelection;